import { useTranslation } from "react-i18next";
import { mainURL } from "../utils/common";

export const ReDirectToeKMC2 = ({ label, classAdd = true }) => {
  const { t } = useTranslation();

  return (
    <a
      className={classAdd ? "nav-link fontSizeClass" : ""}
      href={`${mainURL}/citizen/language-selection`}
      target="_blank"
      rel="noreferrer"
    >
      {t(label)}
    </a>
  );
};
